import { render } from "./XuLyBanVe.vue?vue&type=template&id=6a9c0575&scoped=true"
import script from "./XuLyBanVe.vue?vue&type=script&lang=js"
export * from "./XuLyBanVe.vue?vue&type=script&lang=js"

import "./XuLyBanVe.vue?vue&type=style&index=0&id=6a9c0575&lang=css&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9c0575"]])

export default __exports__